<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ (companyId ? "company.edit" : "company.create") | translate }}
    </ion-title>

    @if(!state.isBigScreen){
    <ion-buttons slot="start">
      <ion-button type="button" (click)="cancel()" [disabled]="saving">
        <ion-icon
          name="arrow-back-outline"
          slot="icon-only"
        ></ion-icon> </ion-button
    ></ion-buttons>
    } @if(state.isBigScreen){
    <ion-buttons slot="end">
      <ion-button type="button" (click)="cancel()" [disabled]="saving">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button> </ion-buttons
    >}
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form" (ngSubmit)="save()">
    <!-- Stammdaten -->
    <ion-list>
      <!-- Name -->
      <ion-item
        [class.ion-invalid]="hasError('name')"
        [class.ion-touched]="hasError('name')"
      >
        <ion-input
          formControlName="name"
          [label]="('common.name' | translate) + ' *'"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          autocomplete="organization"
        >
        </ion-input>
      </ion-item>

      @if (hasError('name')) {
      <ion-note class="error-message">{{
        "company.nameRequired" | translate
      }}</ion-note>
      }

      <!-- Company Number -->
      <ion-item>
        <ion-input
          formControlName="companyNumber"
          [label]="'company.number' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <!-- Address -->
      <ion-item
        [class.ion-invalid]="hasError('address')"
        [class.ion-touched]="hasError('address')"
      >
        <ion-input
          formControlName="address"
          [label]="('company.address' | translate) + ' *'"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          autocomplete="street-address"
        >
        </ion-input>
      </ion-item>

      @if (hasError('address')) {
      <ion-note class="error-message">{{
        "company.addressRequired" | translate
      }}</ion-note>
      }

      <!-- Postal Code -->
      <ion-item
        [class.ion-invalid]="hasError('postalCode')"
        [class.ion-touched]="hasError('postalCode')"
      >
        <ion-input
          formControlName="postalCode"
          [label]="('company.postalCode' | translate) + ' *'"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          inputmode="numeric"
          autocomplete="postal-code"
        >
        </ion-input>
      </ion-item>

      @if (hasError('postalCode')) {
      <ion-note class="error-message">
        {{ "company.postalCodeRequired" | translate }}
      </ion-note>
      }

      <!-- City -->
      <ion-item
        [class.ion-invalid]="hasError('city')"
        [class.ion-touched]="hasError('city')"
      >
        <ion-input
          formControlName="city"
          [label]="('company.city' | translate) + ' *'"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          autocomplete="address-level2"
        >
        </ion-input>
      </ion-item>

      @if (hasError('city')) {
      <ion-note class="error-message">{{
        "company.cityRequired" | translate
      }}</ion-note>
      }

      <!-- State -->
      <ion-item
        [class.ion-invalid]="hasError('state')"
        [class.ion-touched]="hasError('state')"
      >
        <ion-select
          formControlName="state"
          [label]="('company.state' | translate) + ' *'"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          interface="popover"
          [placeholder]="'company.selectState' | translate"
        >
          @for (state of germanStates; track state) {
          <ion-select-option [value]="state.code">
            {{ state.name }}
          </ion-select-option>
          }
        </ion-select>
      </ion-item>

      @if (hasError('state')) {
      <ion-note class="error-message">
        {{ "company.stateRequired" | translate }}
      </ion-note>
      }

      <!-- E-Mail -->
      <ion-item
        [class.ion-invalid]="hasError('mail')"
        [class.ion-touched]="hasError('mail')"
      >
        <ion-input
          formControlName="mail"
          [label]="'common.email' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="email"
          autocomplete="email"
        >
        </ion-input>
      </ion-item>

      @if (hasError('mail')) {
      <ion-note class="error-message">
        {{ "company.emailInvalid" | translate }}
      </ion-note>
      }

      <!-- Phone -->
      <ion-item>
        <ion-input
          formControlName="phone"
          [label]="'common.phone' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="tel"
          autocomplete="tel"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="basicAccounting"
          [label]="'company.hourAccounting' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="badWeatherAccounting"
          [label]="'company.badWeatherAccounting' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="publicHolidayAccounting"
          [label]="'company.holidayAccounting' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="sicknessAccounting"
          [label]="'company.sicknessAccounting' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="vacationAccounting"
          [label]="'company.vacationAccounting' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-textarea
          formControlName="defaultConSiteFolders"
          [label]="'company.defaultFolders' | translate"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          [placeholder]="'company.folderExamples' | translate"
          autoGrow="true"
        >
        </ion-textarea>
      </ion-item>

      <ion-note class="field-hint">
        Mehrere Ordner können durch Kommas getrennt angegeben werden.
      </ion-note>
    </ion-list>

    <!-- Actions -->
    <div class="actions">
      <ion-button
        type="button"
        fill="outline"
        expand="block"
        (click)="cancel()"
        [disabled]="saving"
      >
        Abbrechen
      </ion-button>

      <ion-button type="submit" expand="block" [disabled]="saving">
        @if (!saving) {
        <span>
          {{ companyId ? "Änderungen speichern" : "Firma erstellen" }}
        </span>
        }
      </ion-button>
    </div>
  </form>
</ion-content>
